export default {
  API_URL: "http://localhost:8085",
  IMAGE_API_URL: "http://localhost:8085",
  FILE_API_URL: "http://localhost:8085",
  APP_URL: "/",
  // API_URL: 'https://api.arivilloso.com',
  // IMAGE_API_URL: 'https://thumb.arivilloso.com',
  // FILE_API_URL: 'https://files.arivilloso.com'
};
